import { Seo } from "../components/Seo";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { ServicesBento } from "../components/ServicesBento";
import { Process } from "../components/Process";
import { Pillars, WhyProposal, ServiceArea, Operations, Audiences } from "../components/HomeSections";
import { QuoteCTA } from "../components/QuoteCTA";

export default function Home() {
  return (
    <>
      <Seo
        title="Commercial Cleaning Company Peoria, Glendale & Surprise AZ | Shine Solutions"
        description="Professional recurring commercial cleaning for offices, retail spaces, healthcare facilities and commercial properties in the Phoenix West Valley. Free quotes."
        path="/"
      />
      <Hero />
      <Marquee />
      <Audiences />
      <ServicesBento />
      <Process />
      <Pillars />
      <WhyProposal />
      <ServiceArea />
      <Operations />
      <QuoteCTA />
    </>
  );
}
